import { FC } from "react";

interface PendingAdvancesAlertProps {
  pendingCount: number;
  message?: string;
}

export const PendingAdvancesAlert: FC<PendingAdvancesAlertProps> = ({ pendingCount, message }) => {
  const defaultMessage = `Há ${pendingCount} ${
    pendingCount > 1 ? "solicitações" : "solicitação"
  } de adiantamento pendente${pendingCount > 1 ? "s" : ""} para aprovação. Deseja continuar mesmo assim?`;

  return (
    <div className="flex items-start gap-3 p-4 bg-amber-50 border border-amber-200 rounded-lg">
      <svg className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
        <path
          fillRule="evenodd"
          d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
          clipRule="evenodd"
        />
      </svg>
      <div className="flex-1">
        <p className="text-sm font-medium text-amber-900">Atenção: Existem adiantamentos pendentes</p>
        <p className="text-sm text-amber-700 mt-1">{message || defaultMessage}</p>
      </div>
    </div>
  );
};
